module.exports = __webpack_public_path__ + "omlazeni-pleti_1_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/laserova-estetika/omlazeni-pleti_1_before_tn.jpg
// module id = 1482
// module chunks = 0